import fetchData from './fetchData';
import getWPPage from '../../ui/wp-page';

const WPPage = getWPPage(fetchData);

export default WPPage;
